export default "__VITE_ASSET__Clv8xjeo__"